const SYSLOG_SEVERITY_LEVEL = {
    CRITICAL: 2,
    ERROR: 3,
    WARNING: 4,
    INFORMATIONAL: 6,
    DEBUG: 7,
};

const SYSLOG_FACILITY = {
    KERNEL: 0,
    USER_LEVEL: 1,
    MAIL_SYSTEM: 2,
    SYSTEM_DAEMONS: 3,
    SECURITY_SMS_DEFAULT: 4,
    INTERNAL: 5,
    LINE_PRINTER: 6,
    NETWORK_NEWS: 7,
    UUCP: 8,
    CLOCK_DAEMON_1: 9,
    SECURITY: 10,
    FTP_DAEMON: 11,
    NTP: 12,
    LOG_AUDIT: 13,
    LOG_ALERT: 14,
    CLOCK_DAEMON_2: 15,
    LOCAL_0: 16,
    LOCAL_1: 17,
    LOCAL_2: 18,
    LOCAL_3: 19,
    LOCAL_4: 20,
    LOCAL_5: 21,
    LOCAL_6: 22,
    LOCAL_7: 23,
};

const ULS_EVENT_TYPE = {
    TRANSACTION: 'app.logic.trxtrace',
    TRANSACTION_FAILURE: 'app.logic.failure',
    TRANSACTION_START: 'app.logic.trxstart',
    TRANSACTION_FINISH: 'app.logic.trxfinish',
    ENTITLEMENTS_CHANGE: 'app.logic.entitlement',
    ACCESS_APP: 'app.logic.access',
    LOGIN: 'app.auth.login',
    REGISTER: 'app.auth.reg',
};

module.exports = { SYSLOG_SEVERITY_LEVEL, SYSLOG_FACILITY, ULS_EVENT_TYPE };
